import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class StaticServiceProviderFileGroupingModel extends ModelBase {

    public staticServiceProviderFileGroupingId: number = 0;

    public staticServiceProviderId: number = 0;

    public serviceProviderGroupingName: string = "All";

    public groupingDescription: string = "";

    public isActiveInd: boolean = false;

    public isBookCostRunning: boolean = false;
}